import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { Amplify } from 'aws-amplify';
import amplifyConfig from './amplify-config'; // Import the configuration from the new file

Amplify.configure(amplifyConfig); // Configure Amplify

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
